module.exports = __webpack_public_path__ + "static/media/WILLPOWER_MEDIUM.df04b394.md";